import { useQuery } from '@tanstack/react-query';
import { listOrgMcpTools } from '@/services/org-mcp-tools/org-mcp-tools';
import { OrgMcpTool } from '@/services/org-mcp-tools/types';

export const orgMcpToolsQueryKey = (orgId?: string) => ['org-mcp-tools', orgId];

export const useListOrgMcpTools = (orgId?: string) => {
  return useQuery<OrgMcpTool[]>({
    queryKey: orgMcpToolsQueryKey(orgId),
    queryFn: () => listOrgMcpTools(orgId!),
    enabled: !!orgId,
  });
};
